module.exports = __webpack_public_path__ + "static/img/6.156178a1.png";